Checklist = require 'app/scripts/models/checklist'
CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'

class ChecklistList extends CollectionWithHelpers
  model: Checklist
  initialize: ->
    @listenTo(@, 'change:pos', @sort)

  comparator: (checklist) ->
    checklist.get('pos')

  idList: -> @pluck('id')

module.exports = ChecklistList
